import { render } from "./AppLogo.vue?vue&type=template&id=5b00fb35&scoped=true"
const script = {}

import "./AppLogo.vue?vue&type=style&index=0&id=5b00fb35&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b00fb35"]])

export default __exports__